import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'
import { ENTITY_TYPES } from '@sales-center/common'
import { CreateLocationFormWrapper } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/CreateLocationForm/CreateLocationFormWrapper'

const DIALOG_WIDTH = 598
const DIALOG_HEIGHT = '90vh'

export type CreateLocationModalProps = {
  open: boolean
  onClose: () => void
  entityId: number
  entityType: ENTITY_TYPES
  title: string
  onNewLocationsSave: () => void
  tidalThemeActive?: boolean
  addToPestPac?: boolean
}

export function CreateLocationModal(props: CreateLocationModalProps) {
  const {
    open,
    onClose,
    entityId,
    entityType,
    title,
    onNewLocationsSave,
    tidalThemeActive,
    addToPestPac,
  } = props

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={isMobile}
      data-test-id="create-location-modal"
      PaperProps={{
        sx: {
          position: 'relative',
          ...(isMobile
            ? { width: '100%', height: '100%' }
            : {
                width: DIALOG_WIDTH,
                maxWidth: 'calc(100% - 64px)',
                height: DIALOG_HEIGHT,
              }),
        },
      }}
    >
      <IconButton
        aria-label="Close"
        data-test-id="create-location-modal-close"
        onClick={onClose}
        sx={{ position: 'absolute', top: 12, right: 12, zIndex: 1 }}
      >
        <CloseIcon />
      </IconButton>
      <CreateLocationFormWrapper
        entityId={entityId}
        entityType={entityType}
        title={title}
        tidalThemeActive={tidalThemeActive}
        onCloseNewLocation={onClose}
        onNewLocationsSave={onNewLocationsSave}
        containerTop="56px"
        addToPestPac={addToPestPac}
      />
    </Dialog>
  )
}
CreateLocationModal.displayName = 'CreateLocationModal'
